import { classnames } from '@bem-react/classnames'
import type { IconComponent } from '@consta/icons/Icon'
import { IconClose } from '@consta/icons/IconClose'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import type { Nullable } from 'common/types'
import type { ComponentProps, PropsWithChildren } from 'react'
import { forwardRef, memo } from 'react'

import css from './ModalHeader.css'

type ModalHeaderProps = ComponentProps<'div'> & {
  title: string
  onCloseClick: () => void
  icon: Nullable<IconComponent>
}

export const ModalHeader = memo(
  forwardRef<HTMLDivElement, PropsWithChildren<ModalHeaderProps>>(function ModalHeader(
    { icon: Icon, title, className, onCloseClick, children, ...rest },
    ref,
  ) {
    return (
      <div ref={ref} className={classnames(css.modalHeader, className)} {...rest}>
        <div className={css.title}>
          {!!Icon && <Icon size="s" view="ghost" />}
          <Text size="s" view="secondary">
            {title}
          </Text>
        </div>
        <div className={css.controls}>
          {children}
          <Button
            onlyIcon={true}
            iconSize="xs"
            iconLeft={props => <IconClose {...props} view="secondary" />}
            view="clear"
            size="xs"
            onClick={onCloseClick}
          />
        </div>
      </div>
    )
  }),
)
